import { Navigate } from "react-router-dom";
import  {useAuth}  from "../hooks/useAuth.jsx";
import { useLocation } from "react-router-dom";

/**
 * Requires a logged-in user and, when `roles` is given, one of those roles;
 * anyone else goes back to the home page.
 */
export const ProtectedRoute = ({ children, roles }) => {

const location = useLocation();
const { user } = useAuth();
  if (!user) {
    return <Navigate to="/login" state={{ from: location }}  />;
  }
  if (roles && !(user.user?.roles ?? []).some((role) => roles.includes(role.name))) {
    return <Navigate to="/" replace />;
  }
  return children;
};
